import React, { useEffect } from "react";
import { Box, CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Navbar } from "./Components/Navbar";
import { HeroSection } from "./Components/HeroSection";
import { FeaturesSection } from "./Components/FeaturesSection";
import { WhyChooseUsSection } from "./Components/WhyChooseUsSection";
import { Footer } from "./Components/Footer";
import { useGetUserPublic } from "../Hooks/UseGetUserPublic";
import { useParams } from "react-router-dom";
import { useContextLandingPages } from "src/Contexts/LandingPageContext/LandingPagesContext";

const defaultTheme = createTheme();

export const LandingPages0001 = () => {
  const { idTenant } = useParams();

  const { sellerData } = useContextLandingPages();
  const { handleGetUserPublic } = useGetUserPublic();

  useEffect(() => {
    if (idTenant) {
      handleGetUserPublic(idTenant);
    }
  }, []);

  return (
    <ThemeProvider theme={defaultTheme}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          backgroundColor: "#F9FAFB" /* Cor de fundo geral clara */,
        }}
      >
        <CssBaseline />
        <Navbar sellerData={sellerData} />
        <HeroSection />
        <WhyChooseUsSection />
        <FeaturesSection />
        <Footer sellerData={sellerData} />
      </Box>
    </ThemeProvider>
  );
};
